import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48f56784")

_pushScopeId("data-v-48f56784")
const _hoisted_1 = {
  ref: "el",
  class: "list__wrapper"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Bouncing = _resolveComponent("Bouncing")
  const _component_List = _resolveComponent("List")
  const _component_Nullable = _resolveComponent("Nullable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Bouncing, {
          key: 0,
          class: "anim my-12",
          style: `top: -${_ctx.refreshThreshold}px`
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Nullable, { content: _ctx.listData }, {
      default: _withId(() => [
        _createVNode(_component_List, _mergeProps({ "list-data": _ctx.listData }, _ctx.attrs, { class: _ctx.listClass }), {
          prepend: _withId(() => [
            _renderSlot(_ctx.$slots, "prepend", {}, undefined, true)
          ]),
          default: _withId(({ item }) => [
            _renderSlot(_ctx.$slots, "default", { item: item }, undefined, true)
          ]),
          append: _withId(() => [
            _renderSlot(_ctx.$slots, "append", {}, undefined, true)
          ]),
          _: 1
        }, 16, ["list-data", "class"])
      ]),
      _: 1
    }, 8, ["content"])
  ], 512))
})